export { default } from './svg/paint-brush.svg';
